import { graphql, useStaticQuery } from 'gatsby';
import {
    CTAConfiguration,
    KontentRadioMultiChoice,
    KontentRichText,
    KontentStringValue,
} from '../../../../types/KontentProps';

export interface Faq {
    id?: string;
    preferred_language: string;
    elements: CTAConfiguration & {
        question: KontentStringValue;
        answer: KontentRichText;
        blog_topic: KontentRadioMultiChoice<string>;
        country: KontentRadioMultiChoice<string>;
        wellness_type: KontentRadioMultiChoice<string>;
        product_type: KontentRadioMultiChoice<string>;
        product_family: KontentRadioMultiChoice<string>;
        content_type: KontentRadioMultiChoice<string>;
        department: KontentRadioMultiChoice<string>;
    };
}

interface FaqQuery {
    allKontentItemContentItemFaq: {
        nodes: Faq[];
    };
}

export const useFaqs = (): Faq[] => {
    const faqs: FaqQuery = useStaticQuery(graphql`
        {
            allKontentItemContentItemFaq(
                filter: { system: { workflow_step: { ne: "archived" } } }
            ) {
                nodes {
                    ...kontentFaq
                }
            }
        }
    `);

    return faqs.allKontentItemContentItemFaq.nodes;
};
